import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'What was your biggest win recently?',
    field: 'biggestWinRecently',
    type: 'info',
    answer: {
      type: 'text',
      name: 'biggestWinRecentlyDesc',
      placeholder: ''
    }
  },

  {
    label:
      'What changes have you noticed since creating your goal with the kinesiologist?',
    field: 'changesNoticedSinceCreatingYourGoalWithKinesiologist',
    type: 'info',
    answer: {
      type: 'text',
      name: 'changesNoticedSinceCreatingYourGoalWithKinesiologistDesc',
      placeholder: ''
    }
  },

  {
    label: 'What do you feel is working well for you right now?',
    field: 'whatDoYouFeelIsWorkingWellForYouRightNow',
    type: 'info',
    answer: {
      type: 'text',
      name: 'whatDoYouFeelIsWorkingWellForYouRightNowDesc',
      placeholder: ''
    }
  },

  {
    label:
      'What challenges, if any, have you experienced while working on achieving your goal',
    field: 'whatChallengesExperiencedWhileWorkingOnAchievingYourGoal',
    type: 'info',
    answer: {
      type: 'text',
      name: 'whatChallengesExperiencedWhileWorkingOnAchievingYourGoalDesc',
      placeholder: ''
    }
  },

  {
    label:
      'In a typical week, how many minutes of aerobic physical activity are you doing? Aerobic activity includes anything that increases your heart rate and breathing through repetitive, rhythmic movements, such as jogging, cycling, dancing, or hiking.',
    field: 'minutesOfAerobicPhysicalActivityPerWeek',
    type: 'info',
    answer: {
      name: 'minutesOfAerobicPhysicalActivityPerWeekDesc',
      type: 'number',
      min: 0,
      placeholder: 'Minutes per week'
    }
  },

  {
    label:
      'When you are doing aerobic physical activity, do you feel that you:',
    field: 'feelingAfterDoingAerobicPhysicalActivity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'vigorousEffort',
          value: 'Make a vigorous effort (e.g. jogging, can barely speak)'
        },
        {
          key: 'moderateEffort',
          value:
            'Make a moderate effort (e.g. brisk walking, can speak but not sing)'
        },
        {
          key: 'lightEffort',
          value:
            'Make a light effort (e.g. standing, light housework, shopping, light gardening)'
        }
      ]
    }
  },

  {
    label:
      'How many days per week do you exercise your muscles using resistance (i.e. dumbbells, machines at a gym, exercise bands, or body weight)?',
    field: 'daysPerWeekExerciseMuscleResistance',
    type: 'info',
    answer: {
      name: 'daysPerWeekExerciseMuscleResistanceDesc',
      type: 'number',
      min: 0,
      max: 7,
      placeholder: 'Days'
    }
  },

  {
    label: 'How long is your resistance exercise session?',
    field: 'resistanceExerciseSessionLengthInMinuets',
    type: 'info',
    answer: {
      name: 'resistanceExerciseSessionLengthInMinuetsDesc',
      type: 'number',
      min: 0,
      placeholder: 'Minutes'
    }
  }
];

export default questionsModels;
